var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeButton = function SvgHomeButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E6F1F2",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131B20",
    d: "M30.392 14v12l-10.391 6-10.393-6V14L20 8zm-18.786 1.154v9.692L20 29.693l8.394-4.847v-9.692l-8.393-4.847zm14.587 1.13v7.433l-6.438 3.716-6.436-3.716v-7.433l6.436-3.717zm-10.876 1.153v5.126l4.438 2.564 4.44-2.564v-5.126l-4.44-2.563zm6.962 1.129v2.866l-2.483 1.434-2.481-1.434v-2.866l2.481-1.433zm-2.966 1.153v.56l.483.28.485-.28v-.56l-.485-.28z"
  })));
};
export { SvgHomeButton as ReactComponent };
export default __webpack_public_path__ + "b7c00a3c1d55ede8cc208247d448ec97.svg";